import types from './types';

import { authenticationService } from '../../services';

const initialState = {
  customerCode: authenticationService.currentUserValue
    && authenticationService.currentUserValue.customerCode,
  isGlobalConfEditCustomer: authenticationService.currentUserValue
    && authenticationService.currentUserValue.isGlobalConfEditCustomer,
};

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.LOG_IN: {
      const {
        customerCode,
        isGlobalConfEditCustomer,
      } = action.payload;

      return {
        ...state,
        customerCode,
        isGlobalConfEditCustomer,
      };
    }
    case types.LOG_OUT: {
      return {};
    }
    default:
      return state;
  }
};

export default sessionReducer;
